import {useEffect, useState} from "react";
import {motion} from "framer-motion";
import {ITransaction} from "../../utils/interfaces/ITransaction";
import {IDetailTransaction} from "../../utils/interfaces/IDetailTransaction";
import DetailTransactionRow from "./DetailTransactionRow";


interface DetailsTransactionListProps {
    obj?: ITransaction,
    detail_transactions?: IDetailTransaction[],
    onClose?: () => void;
}

function DetailsTransactionList({
                                    obj: initialObj,
                                    detail_transactions: initialDetailsTransactions,
                                    onClose,
                                }: DetailsTransactionListProps) {
    const [obj, setObj] = useState<ITransaction | undefined>(initialObj)
    const [detailTransactions, setDetailTransactions] = useState<IDetailTransaction[] | undefined>(initialDetailsTransactions)

    const generateDetailTransactionRow = (obj: IDetailTransaction, index: any) => (
        <motion.tr
            initial={{opacity: 0, y: 30}}
            animate={{opacity: 1, y: 0}}
            exit={{opacity: 0, y: -10}}
            transition={{duration: 0.5}}
            // className={
            //     obj.type === 'refund'
            //         ? 'bg-mcia_accounting_refund'
            //         : obj.type === 'rebound'
            //             ? 'bg-mcia_accounting_rebound'
            //             : ''
            // }
        >
            <DetailTransactionRow obj={obj}/>
        </motion.tr>
    );

    const mapped_objs = obj?.details.map(generateDetailTransactionRow);
    const detail_transactions = detailTransactions?.map(generateDetailTransactionRow);

    useEffect(() => {
        if (initialObj) {
            setObj(initialObj)
        }
    }, [initialObj])

    useEffect(() => {
        if (initialDetailsTransactions) {
            setDetailTransactions(initialDetailsTransactions)
        }
    }, [initialDetailsTransactions])

    return (
        <div className=''>
            <motion.table
                className="bg-mcia_gray_soft shadow-xl rounded-lg p-4 mb-4 w-[500px] relative"
                initial={{x: '100%'}}
                animate={{x: '0%'}}
                transition={{duration: 0.2}}
            >

                <thead className='mycia_thead'>
                <tr className='mb-0.5'>
                    <th className="mycia_th rounded-tl">
                        <span className="mr-2">Order</span>
                        <span className="mr-8">Id</span>
                    </th>
                    <th className="mycia_th">
                        <span className="mr-2">Balance</span>
                        <span className="mr-8"></span>
                    </th>
                    <th className="mycia_th">
                        <span className="mr-2">Net Amount</span>
                    </th>
                    <th className="mycia_th ">
                        <span className="mr-0">Stripe Comm.</span>
                    </th>
                    <th className="mycia_th ">
                        <span className="mr-0">Total Comm.</span>
                    </th>
                    <th className="mycia_th ">
                        <span className="mr-2">Type</span>
                    </th>
                    <th className="mycia_th">
                        <span className="mr-2">rebound</span>
                    </th>
                    <th className="mycia_th rounded-tr">
                        <span className="mr-2">Date</span>
                    </th>

                </tr>
                </thead>
                <tbody>
                {mapped_objs}
                {detail_transactions}
                </tbody>
                <tfoot className=''>
                <tr className=''>
                    <th className="mycia_tf rounded-bl">
                        <span className="mr-2"></span>
                        <span className="mr-8"></span>
                    </th>
                    <th className="mycia_tf">
                        <span className="mr-2"></span>
                        <span className="mr-8"></span>
                    </th>
                    <th className="mycia_tf">
                        <span className="mr-2"></span>
                        <span className="mr-1"></span>
                        <span className="mr-8"></span>
                    </th>
                    <th className="mycia_tf ">
                        <span className="mr-2"></span>
                        <span className="mr-2"></span>
                    </th>
                    <th className="mycia_tf ">
                        <span className="mr-2"></span>
                        <span className="mr-2"></span>
                    </th>
                    <th className="mycia_tf ">
                        <span className="mr-2"></span>
                    </th>
                    <th className="mycia_tf">
                        <span className="mr-2"></span>
                    </th>
                    <th className="mycia_tf rounded-br">
                        {onClose && (
                            <button className='mycia_closing_form_button' onClick={onClose}>Close</button>
                        )}
                    </th>

                </tr>
                </tfoot>


            </motion.table>


        </div>
    )
}

export default DetailsTransactionList;